export function sovereignCreditDirection(text: string): -1 | 0 | 1 {
  const hasSovereignCreditSource =
    /\b(fitch|moody'?s|s&p|standard\s+&\s+poor'?s|ratings?\s+agenc(?:y|ies)|sovereign)\b/.test(
      text,
    );
  if (!hasSovereignCreditSource) return 0;
  if (
    /\b(fiscal\s+deficits?|budget\s+deficits?|debt\s+(?:burden|load|sustainability)|structural\s+revenue\s+decline|revenue\s+decline|downgrad(?:e|ed|es|ing)|negative\s+outlook|rating\s+outlook\s+negative|complicate\s+deficit\s+reduction)\b/.test(
      text,
    )
  )
    return -1;
  if (
    /\b(upgrad(?:e|ed|es|ing)|positive\s+outlook|deficit\s+(?:narrows?|improves?)|debt\s+sustainability\s+improves?)\b/.test(
      text,
    )
  )
    return 1;
  return 0;
}
